export const hasOneOf = <T>(needles: T | T[], hayStack: T[] = []) => {
    if (Array.isArray(needles)) {
        for (const needle of needles) {
            if (hayStack.some(straw => straw === needle)) {
                return true;
            }
        }
        return false;
    } else {
        return hayStack.some(straw => straw === needles);
    }
};
